import React, { useState, useEffect } from "react";
import { Button, Drawer, Modal, theme, Switch } from "antd";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import Logo from "../../assets/images/logo.png";
import SettingIcon from "../../assets/images/settings-icon.svg"; 
import CoociesIcon from "../../assets/images/cookie-icons.svg"; 
import ThemeModal from "./ThemeModal";
import { MoonOutlined, SunOutlined } from "@ant-design/icons";

export default function HeaderIndex() {
 const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [switchTheme, setSwitchTheme] = useState("auto");

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const [CookieisModalOpen, setIsModalOpenCookie] = useState(false);

  const CookieshowModal = () => {
    setIsModalOpenCookie(true);
  };

  const CookiehandleOk = () => {
    setIsModalOpenCookie(false);
  };

  const CookiehandleCancel = () => {
    setIsModalOpenCookie(false);
  };

    const [darkMode, setDarkMode] = useState(
        () => localStorage.getItem("theme") === "dark"
    );

 
  useEffect(() => {
    document.body.classList.add("imergey-body");
    return () => {
      document.body.classList.remove("imergey-body");
    };
  }, []);

    const handleSwitchTheme = (e) => {
        setSwitchTheme(e)
        localStorage.setItem("theme", e == "dark" ? "dark" : "main");
    }

    
    useEffect(() => {
        const existingLink = document.getElementById("theme-style");
        if (existingLink) {
        existingLink.remove();
        }
        const link = document.createElement("link");

        link.id = "theme-style";
        link.rel = "stylesheet";
        link.href = darkMode ? "/main.css" : "/dark.css";
        document.head.appendChild(link);

        localStorage.setItem("theme", darkMode ? "dark" : "main");
        return () => {
        link.remove();
        };
    }, [darkMode]);

  return (
    <>
      <div className="setting-theme-change" onClick={showModal}>
        <img src={SettingIcon} alt="Setting" />
      </div>

      <Navbar  expand="lg" className="header-main">
        <Container>
          <Navbar.Brand href="#" className="p-0 m-0">
            <div className="logo-image">
              <img src={Logo} alt="Logo" />
            </div>
          </Navbar.Brand>

          <div className="d-lg-none ms-auto">
            <Button
              className="menu-toggle"
              type="text"
              onClick={() => setIsDrawerOpen(true)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </Button>
          </div>

          <Navbar.Collapse id="basic-navbar-nav" className="d-none d-lg-flex">
            <Nav className="mx-auto navbar-menu">
              <Nav.Link href="#" className="menu-link active">
                Home
              </Nav.Link>
              <Nav.Link href="#whoweare" className="menu-link">
                What we are
              </Nav.Link>
              <Nav.Link href="#whatwedo" className="menu-link">
                What we do
              </Nav.Link>
              <Nav.Link href="#howitwork" className="menu-link">
                How it works
              </Nav.Link>
              <Nav.Link href="#insights" className="menu-link">
                Insights
              </Nav.Link>
              <Nav.Link href="#faq" className="menu-link">
                FAQ’s
              </Nav.Link>
            </Nav>
            <div className="header-buttons">
              <Button className="fill-btn">Start a free trial!</Button>
              <Button className="outline-btn"  onClick={CookieshowModal}>Login</Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Drawer
        width={"100%"}
        placement="right"
        onClose={() => setIsDrawerOpen(false)}
        open={isDrawerOpen}
        className="mobile-menu-drawer"
      >
        
 
        <Nav className="flex-column mobile-menu">
          <Nav.Link
            href="#"
            className="menu-link active"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              setIsDrawerOpen(false);
            }}
          >
            Home
          </Nav.Link>
          <Nav.Link
            href="#whoweare"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            What we are
          </Nav.Link>
          <Nav.Link
            href="#whatwedo"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            What we do
          </Nav.Link>
          <Nav.Link
            href="#howitwork"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            How it works
          </Nav.Link>
          <Nav.Link
            href="#insights"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            Insights
          </Nav.Link>
          <Nav.Link
            href="#faq"
            className="menu-link"
            onClick={() => setIsDrawerOpen(false)}
          >
            FAQ’s
          </Nav.Link>
          <div className="header-buttons mt-4">
            <Button className="fill-btn mb-2 w-100">Start a free trial!</Button>
            <Button className="outline-btn w-100">Login</Button>
          </div>
        </Nav>
      </Drawer>

      <ThemeModal
        open={isModalOpen}
        onClose={handleCancel}
        switchTheme={(e) => handleSwitchTheme(e)}
        switchThemeval={switchTheme}
      />

<Modal title="" open={CookieisModalOpen} footer={false} closable={false}>
         <div className="coocies-main-modal">
            <img src={CoociesIcon} />
            <h6>Cookie Consent</h6>
            <p>We use necessary cookies to make our site work. We’d like to set additional cookies to understand site usage, make site improvements and to remember your settings. We also use cookies set by other sites to help deliver content from their services. </p>
            <div className="coocies-footer-modal">
                <Button onClick={CookiehandleOk}  className="fill-btn">Accept & continue</Button>
                <Button onClick={CookiehandleCancel} className="outline-btn">Decline cookies</Button>
            </div>
         </div>
      </Modal>


    </>
  );
}
